<template>
  <div class="common-layout">
    <login v-if="!isLogin"></login>
    <el-container v-else style="height: 100%">
      <!-- 头部 -->
      <el-header>
        <Header :isCollapse="isCollapse"></Header>
      </el-header>
      <el-container>
        <!-- 左侧菜单 -->
        <slider-bar
          @add-tab="addTab"
          @default-Page="getDefaultPage"
          @change-collapse="changeCollapse"
        ></slider-bar>
        <!-- 中间内容 -->
        <el-main>
          <el-tabs
            v-model="editableTabsValue"
            type="card"
            class="custom-tabs"
            closable
            @tab-remove="removeTab"
          >
            <el-tab-pane
              class="custom-tab-pane"
              v-for="item in editableTabs"
              :key="item.name"
              :label="item.title"
              :name="item.name"
            >
              <component
                :is="item.component"
                :tableMaxHeight="tableMaxHeight"
                ref="cleanRef"
                :iSclean="iSclean"
                :editId="editId"
                @add-tab="addTab"
                @removeTab2="removeTab2"
                @updateTab="updateTab"
              ></component>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Login from "views/Login";
import Header from "../views/layout/Header.vue";
import SliderBar from "../views/layout/SliderBar.vue";
import { reactive, toRefs, computed, toRaw,ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
export default {
  name: "Index",
  components: {
    Header,
    SliderBar,
    Login,
  },

  setup() {
    const store = useStore();
    const cleanRef = ref();
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      isCollapse: false, //切换菜单折叠
      editableTabsValue: "2", //指定当前选中的标签页
      editableTabs: [], //标签页
      iSclean:false,
      editId:0,
      comps: [],
      // 表的最大高度:动态计算
      tableMaxHeight: computed(() => {
        const h =
          document.documentElement.clientHeight || document.body.clientHeight;
        return h - 220;
      }),
      // 登录状态
      isLogin: computed(() => {
        return store.state.isLogin || sessionStorage.getItem("isLogin");
      }),
    });
    // 获取默认页面参数
    const getDefaultPage = (val) => {
      // console.log(val, "获取默认页面参数");
      if (val) {
        if (JSON.stringify(data.comps) == "[]") {
          data.comps.push(val);
          defaultComponent();
        } else {
          data.comps.map((item) => {
            if (item.title != val.title) {
              data.comps.push(val);
              defaultComponent();
            }
          });
        }
      } else {
        ElMessage.warning("未设置默认菜单");
      }
    };
    // 默认展示页面
    function defaultComponent() {
      data.comps.map((item) => {
        data.editableTabs.push({
          title: item.title,
          name: item.name,
          content: item.title,
          component: require(`./tabpane/${item.component}.vue`).default,
        });
        data.editableTabsValue = item.name;
      });
    }
    // 点击左侧菜单打开窗口
    const addTab = (targetObj) => {
     
      data.editableTabsValue = targetObj.name; //渲染标签页
      const newTabName = targetObj.component;
      const tab = JSON.parse(JSON.stringify(data.editableTabs));
      // 同一个窗口不能重复打开 查找是否存在
      const oldtab = tab.find((tab) => tab.component.name === newTabName);
      if (oldtab) {
        ElMessage("当前窗口已打开");
        return false;
      } else {
        if(targetObj.id){
          data.editId = targetObj.id
        }else{
          data.editId = 0
        }
        // 新增窗口
        data.editableTabs.push({
          title: targetObj.title,
          name: targetObj.name,
          content: targetObj.title,
          component: require(`./tabpane/${targetObj.component}.vue`).default,
          // component的值必须与对应的vue文件名保持一致
          // require最常用的方法
          // require(‘http’) 内置模块
          // require(‘./server’) “./”表示当前路径，后面跟的是相对路径
          // require(“…/lib/server”) …/表示上一级目录，后面跟的也是相对路径
        });
      }
    };
   
    const clean = (type)=>{
      cleanRef.value.forEach((item,i)=>{
        try {
          if(type == 1){
            if(item.resetForm1()){
              cleanRef.value.resetForm1()
            }
          }else{
            if(item.resetForm()){
              cleanRef.value.resetForm()
            }
          }
        } catch(err) {
          
        }
      })
  
    };
    
    // 移除窗口
     const removeTab =async (targetName) => {
      let tabs = data.editableTabs;
      if (tabs.length === 1) {
        ElMessage({
          message: "至少保留一个窗口！",
        });
        return false;
      }
      
      if(targetName == 24){
        await clean()
      }else if(targetName == 25){
        await clean(1)
      }
      
      let activeName = data.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      data.editableTabsValue = activeName;
      data.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    };
    const removeTab2 =async (targetName) => {
      let tabs = data.editableTabs;
      if (tabs.length === 1) {
        ElMessage({
          message: "至少保留一个窗口！",
        });
        return false;
      }
      
      let activeName = data.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      data.editableTabsValue = activeName;
      data.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    };
    // 更新列表
    const updateTab=(targetName)=>{
      const indexNow = (data.editableTabs || []).findIndex(
          (item) => item.name === targetName
        );
        // 如果是文章列表页面则刷新，添加文章后刷新列表用
        if (
          cleanRef.value[indexNow] &&
          cleanRef.value[indexNow] != undefined
        ) {
          cleanRef.value[indexNow].updateList();
        }
    };
    const changeCollapse = (bol) => {
      data.isCollapse = bol;
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getDefaultPage,
      addTab,
      removeTab,
      removeTab2,
      changeCollapse,
      cleanRef,
      clean,
      updateTab
    };
  },
};
</script>


<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  height: 100%;
}

.common-layout {
  width: 100%;
  height: 100%;
}
.el-header {
  padding: 0 !important;
  height: 45px !important;
}
.el-container.is-vertical {
  height: 100%;
  flex-direction: column;
}
</style>
